import Feeds from "./Feeds";
import Partners from "./Partners";
import Report from "./Report";
import DefaultOffers from "./DefaultOffers";
import DefaultOffersCpc from "./DefaultOffersCpc";

export default { Feeds, Partners, Report, DefaultOffers, DefaultOffersCpc };


// WEBPACK FOOTER //
// ./src/services/API/components/AdkBanner/index.js